import { render, staticRenderFns } from "./ContentNull.vue?vue&type=template&id=6a5f5ac6&"
import script from "./ContentNull.vue?vue&type=script&lang=js&"
export * from "./ContentNull.vue?vue&type=script&lang=js&"
import style0 from "./ContentNull.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports